export default __webpack_public_path__ + "media/splashpage/bg-full-right-purple-d4f6b018.svg";